import React, { useState } from "react";
import TransactionAccessTable from "./components/TransactionAccessTable";
import TransactionAccessAddEditModal from "./components/TransactionAccessAddEditModal";
import { SearchBar } from "../../../../common/APICommon";

const TransactionAccessModule = ({
  user,
  data,
  searchData,
  updateAccess
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (isFullAccess) => {
    if (!selectedItem) return;

    const payload = {
      isFullTransactionAccess: isFullAccess
    };

    // Audit Trail Preparation
    const auditEntries = [];
    const oldValue = !!selectedItem.isFullTransactionAccess ? "Yes" : "No";
    const newValue = isFullAccess ? "Yes" : "No";

    if (oldValue !== newValue) {
      auditEntries.push({
        setupArea: "Transaction Access",
        actionTaken: "update",
        field: `${selectedItem.description} - Full Transaction Access`,
        oldValue: oldValue,
        newValue: newValue,
        dateSaved: new Date(),
        savedById: user.id
      });
    }

    const res = await updateAccess(selectedItem.id, payload, auditEntries);
    if (res.success) setIsModalOpen(false);
  };

  return (
    <>
      <div className='p-4 space-y-4 relative'>
        <div className="flex justify-between items-center">
          <SearchBar handleFilter={handleSearch} />
        </div>

        <TransactionAccessTable
          data={data}
          onEdit={handleEdit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />

      </div>

      <TransactionAccessAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </>
  );
};

export default TransactionAccessModule;